import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UsEorQuotesDialogComponent } from 'src/app/us-eor-quotes/us-eor-quotes-dialog/us-eor-quotes-dialog.component';
import { AssignmentDialogComponent } from '../../assignments/assignment-dialog/assignment-dialog.component';
import { UserService } from '../../shared/services/user.service';
import { Utils } from '../../shared/utils/utils';
import { AssignmentDialogService } from '../../shared/services/assignment-dialog.service';
import {VendorInvoiceDialogService} from '../../shared/services/vendor-invoice-dialog.service';
import { QuotesDialogComponent } from 'src/app/quotes/quotes-dialog/quotes-dialog.component';
import { IWGSharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-buttonbar',
  templateUrl: './buttonbar.component.html',
  styleUrls: ['./buttonbar.component.scss']
})
export class ButtonbarComponent implements OnInit {

  showCompliance = false;
  ShowQuotesButton = false;
  ShowEngageButton = false;
  ShowEOREstimator = false;
  ShowGetUSEORQuote = false;
  ShowCreateInvoice = false;
  IsWorker = false;

  assignmentDialogClass = ['iwg-form-dialog'];

  Role = '';

  constructor(public router: Router, private utils: Utils, public userService: UserService,
              public dialog: MatDialog, private assignmentDialogService: AssignmentDialogService,
              private vendorinvoicedialog: VendorInvoiceDialogService, private sharedService: IWGSharedService ) { 
  }

  ngOnInit(): void {

    if (this.userService.getEOREstimatorAccess()) {
      this.ShowEOREstimator = true;
    } else {
        this.ShowEOREstimator = false;
    }
    
    var role = this.userService.getRole();
    if (role === 'Worker') {
        this.IsWorker = true;
        this.ShowEOREstimator = false;
    }

    this.showCompliance = !this.userService.getEvaluateButtonDisabled();
    this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
    this.ShowEngageButton = !this.userService.getNewEngageDisabled();

    if (this.userService.getIsSalesManager() || this.userService.getIsSales()) {
      this.ShowGetUSEORQuote = true;
    }

    this.Role = this.userService.getRole();
    if (this.Role === 'Worker'  && !this.userService.getAORDisabled()) {
      this.ShowCreateInvoice = true;
    }
  }

  showQuoteDialog = (ev) => {
    if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayQuoteDialog(ev);
      }
    } else {
        this.displayQuoteDialog(ev);
    }
  }

  displayQuoteDialog = (ev) => {    
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open( QuotesDialogComponent, {
      panelClass: 'iwg-form-dialogfull',
      autoFocus: false,
      data: {existingQuote:null}
    });
    dialogRef.afterClosed().subscribe( result => {
      this.sharedService.isBlurredBg.next(false);            
    });
  }

  showQuoteEstimator = (ev) => {
    if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayQuoteEstimator(ev);
      }
    } else {
        this.displayQuoteEstimator(ev);
    }
  }

  displayQuoteEstimator =  (ev) => {
    this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'],
      {queryParams: {service: 1, global_scope: 2}});
  }

  showQuoteDialogFromEvaluation = (ev, evaluationId, serviceId) => {
    if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayQuoteDialogFromEvaluation(ev, evaluationId, serviceId);
      }
    } else {
        this.displayQuoteDialogFromEvaluation(ev, evaluationId, serviceId);
    }
  }

  displayQuoteDialogFromEvaluation = (ev, evaluationId, serviceId) => {
  }

  showAssignmentDialog = (ev, quoteId= null) => {
    if (this.sharedService.getMyRateDirty()|| this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayAssignmentDialog(ev, quoteId);
      }
    } else {
        this.displayAssignmentDialog(ev, quoteId);
    }
  }

  displayAssignmentDialog = (ev, quoteId= null) => {
    this.assignmentDialogService.show(ev, quoteId);
  }

  showVendorInvoiceDialog = (ev, existingVendorInvoiceId) => {
    if (this.sharedService.getMyRateDirty()|| this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayVendorInvoiceDialog(ev, existingVendorInvoiceId);
      }
    } else {
        this.displayVendorInvoiceDialog(ev, existingVendorInvoiceId);
    }
  }

  displayVendorInvoiceDialog = (ev, existingVendorInvoiceId) => {
    this.vendorinvoicedialog.show(ev, existingVendorInvoiceId);
  }

  showAssignmentDialogWithManagerAndWorker = (ev, quoteId, managerId, workerId, serviceId) => {
    if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayAssignmentDialogWithManagerAndWorker(ev, quoteId, managerId, workerId, serviceId);
      }
    } else {
        this.displayAssignmentDialogWithManagerAndWorker(ev, quoteId, managerId, workerId, serviceId);
    }
  }

  displayAssignmentDialogWithManagerAndWorker = (ev, quoteId, managerId, workerId, serviceId) => {
    this.assignmentDialogService.show(ev, null, quoteId, managerId, workerId, serviceId);
  }

  showUsEorQuoteDialog = (ev) => {
    if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
      if (this.isConfirm()) {
          this.sharedService.setMyRateDirty(false);
          this.sharedService.setAssignmentQuestionDirty(false);
          this.displayUsEorQuoteDialog(ev);
      }
    } else {
        this.displayUsEorQuoteDialog(ev);
    }
  }

  displayUsEorQuoteDialog = (ev) => {
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open( UsEorQuotesDialogComponent, {
      panelClass: 'iwg-form-dialogfull',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe( result => {
      this.sharedService.isBlurredBg.next(false);            
    });
  }

  isConfirm() {
    return confirm('Are you sure you want to leave the page without submitting?')
  }
}
